<template>
	<div class="video-fens">
		<div class="cell-players">
			<!-- 一个屏 -->
			<!-- <div class="cell-player-1" v-if="layoutNum == 1">
				<hw-cell-player :code="vcodes[0]"></hw-cell-player>
			</div>
			<template v-else-if="layoutNum == 4">
				<div class="cell-player-4" v-for="i in Number(layoutNum)" :key="i">
					<hw-cell-player :code="vcodes[i]" v-if="vcodes[i] && vcodes[i].length"></hw-cell-player>
				</div>
			</template> -->

			<div :class="cellClass(i)" v-for="i in Number(layoutNum)" :key="i">
				<hw-cell-player
					:isShowclose="i == 1 && layoutNum == 1 ? false : true"
					:code="vcodes[i - 1]"
					:ref="'hwCellPlayerRef' + (i - 1)"
					v-if="Number(layoutNum) != 6 && Number(layoutNum) != 8 && vcodes[i - 1] && vcodes[i - 1].length"
				></hw-cell-player>
				<hw-cell-player
					:code="vcodes[i - 1]"
					:ref="'hwCellPlayerRef' + (i - 1)"
					v-if="Number(layoutNum) == 6 && i != 2 && i != 3 && vcodes[i - 1] && vcodes[i - 1].length"
				></hw-cell-player>
				<hw-cell-player
					:code="vcodes[i - 1]"
					:ref="'hwCellPlayerRef' + (i - 1)"
					v-if="Number(layoutNum) == 8 && i != 2 && i != 3 && i != 4 && vcodes[i - 1] && vcodes[i - 1].length"
				></hw-cell-player>
				<template v-if="Number(layoutNum) == 6 && i == 2">
					<div class="cell-player-6-2-cell">
						<hw-cell-player
							:code="vcodes[i - 1]"
							:ref="'hwCellPlayerRef' + (i - 1)"
							v-if="vcodes[i - 1] && vcodes[i - 1].length"
						></hw-cell-player>
					</div>
					<div class="cell-player-6-2-cell">
						<hw-cell-player
							:code="vcodes[i]"
							:ref="'hwCellPlayerRef' + i"
							v-if="vcodes[i] && vcodes[i].length"
						></hw-cell-player>
					</div>
				</template>
				<template v-if="Number(layoutNum) == 8 && i == 2">
					<div class="cell-player-8-2-cell">
						<hw-cell-player
							:code="vcodes[i - 1]"
							:ref="'hwCellPlayerRef' + (i - 1)"
							v-if="vcodes[i - 1] && vcodes[i - 1].length"
						></hw-cell-player>
					</div>
					<div class="cell-player-8-2-cell">
						<hw-cell-player
							:code="vcodes[i]"
							:ref="'hwCellPlayerRef' + i"
							v-if="vcodes[i] && vcodes[i].length"
						></hw-cell-player>
					</div>
					<div class="cell-player-8-2-cell">
						<hw-cell-player
							:code="vcodes[i + 1]"
							:ref="'hwCellPlayerRef' + (i + 1)"
							v-if="vcodes[i + 1] && vcodes[i + 1].length"
						></hw-cell-player>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 分屏视频
 */
import HwCellPlayer from './HwCellPlayer.vue'
import bus from '@/api/bus'
export default {
	components: { HwCellPlayer },
	data() {
		return {
			// layoutNum: 1,
			vcodes: [], // 视频的code
		}
	},
	props: {
		// 分了几个栏
		layoutNum: {
			type: Number,
			default: 1,
		},
	},
	computed: {
		cellClass() {
			return function (index) {
				switch (Number(this.layoutNum)) {
					case 1:
						return ['cell-player-1']
					case 4:
						return ['cell-player-4']
					case 6:
						if (index == 1) return ['cell-player-6-1']
						if (index == 2) return ['cell-player-6-2']
						if (index == 3) return ['cell-player-6-none']
						return ['cell-player-6']
					case 8:
						if (index == 1) return ['cell-player-8-1']
						if (index == 2) return ['cell-player-8-2']
						if (index == 3) return ['cell-player-8-none']
						if (index == 4) return ['cell-player-8-none']
						return ['cell-player-8']
					case 9:
						return ['cell-player-9']
					case 16:
						return ['cell-player-16']
					default:
						break
				}
			}
		},
	},
	mounted() {
		// 点击关闭对应的视频
		bus.$on('closeCode', (val) => {
			console.log(val)
			let codeIndex = this.vcodes.findIndex((item) => {
				return item == val
			})
			if (codeIndex > -1) {
				if (this.vcodes.length == 1) {
					this.vcodes = []
				} else {
					this.$set(this.vcodes, codeIndex, '')
				}
			}
		})
	},
	destroyed() {
		bus.$off('closeCode')
	},
	methods: {
		handelUrl(code) {
			if (this.vcodes.indexOf(code) > -1) {
				this.$message('该视频已选中播放', 'error')
				return
			} else {
				this.vcodes.push(code)
			}
		},
		editUrl(code, index) {
			this.$set(this.vcodes, index, code)
		},
	},
}
</script>

<style lang="scss">
.video-fens {
	width: 100%;
	height: 100%;
	background-color: #000;
	.cell-players {
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		border: 1px solid #fff;
	}
	.cell-player {
		border: 1px solid #fff;
	}
	.cell-player-4 {
		width: 50%;
		height: 50% !important;
		box-sizing: border-box;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
	}
	.cell-player-1 {
		width: 100%;
		box-sizing: border-box;
		border: 1px solid #fff;
	}
	.cell-player-6-1 {
		width: 66.66%;
		height: 66.66% !important;
		box-sizing: border-box;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
	}
	.cell-player-6-2 {
		width: 33.33%;
		height: 66.66% !important;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}
	.cell-player-6-none {
		display: none;
	}
	.cell-player-6-2-cell {
		width: 100%;
		height: 50% !important;
		box-sizing: border-box;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
	}
	.cell-player-6 {
		width: 33.33%;
		height: 33.33% !important;
		box-sizing: border-box;
		border-left: 1px solid #fff;
	}

	.cell-player-8-1 {
		width: 75%;
		height: 75% !important;
		box-sizing: border-box;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
	}
	.cell-player-8-2 {
		width: 25%;
		height: 75% !important;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}
	.cell-player-8-none {
		display: none;
	}
	.cell-player-8-2-cell {
		width: 100%;
		height: 33.3% !important;
		box-sizing: border-box;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
	}
	.cell-player-8 {
		width: 25%;
		height: 25% !important;
		box-sizing: border-box;
		border-left: 1px solid #fff;
	}

	.cell-player-9 {
		width: 33.33%;
		height: 33.33% !important;
		box-sizing: border-box;
	}
	.cell-player-16 {
		width: 25%;
		height: 25% !important;
		box-sizing: border-box;
	}
	.cell {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
}
</style>
